import { render, staticRenderFns } from "./BaseRadiobutton.vue?vue&type=template&id=e8997cf6&scoped=true&"
import script from "./BaseRadiobutton.vue?vue&type=script&lang=js&"
export * from "./BaseRadiobutton.vue?vue&type=script&lang=js&"
import style0 from "./BaseRadiobutton.vue?vue&type=style&index=0&id=e8997cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8997cf6",
  null
  
)

export default component.exports